import type {
	AppConfigMasteryLevelsType,
	ReportViewConfig,
} from "@memorang/constants/config/schema";
import type { AiSchemaType } from "@memorang/constants/config/schema";
import { createContext, useContext } from "react";
import type { FontSchemaType } from "../font";

export type AvatarType =
	| "initials"
	| "disco"
	| "glass"
	| "identicon"
	| "shapes"
	| "stripes"
	| "thumbs"
	| "triangles";

export type AppConfigContextValue = {
	buildType?: string;
	avatarType?: AvatarType;
	allowChangeExam?: boolean;
	masteryLevels?: AppConfigMasteryLevelsType;
	proficiencyLevels?: AppConfigMasteryLevelsType;
	proficiencyTargetScore?: number;
	reportView?: ReportViewConfig;
	maxScaledScore?: number;
	hideTotalItemCounts?: boolean;
	allowMarking?: boolean;
	ai?: AiSchemaType;
	appFont?: FontSchemaType;
};

const AppConfigContext = createContext<AppConfigContextValue>({});

export const AppConfigProvider = AppConfigContext.Provider;

export const useAppConfig = (): AppConfigContextValue =>
	useContext(AppConfigContext);
